import { takeEvery } from 'redux-saga/effects';
import actions from '../constants';
import { restrictionsAttachmentsMap } from '../helper';

// eslint-disable-next-line require-yield
export function* clearAttachmentsMap() {
  restrictionsAttachmentsMap.clear();
}

export default function* datasetConditionsAttachments() {
  yield takeEvery(
    [actions.HIDE_DATASET_CONDITION, actions.UPDATE_DATASET_CONDITION_SUCCESS, actions.ADD_DATASET_CONDITION_SUCCESS],
    clearAttachmentsMap,
  );
}
